const isProd = process.env.NODE_ENV === 'production';

export type SiteRegion = 'CN' | 'US' | 'EU';

export const environment = {
  Debug: !isProd,
  Verbose: !isProd,
  Development: !isProd,
  Region: 'CN',
  NoRedirect: true,
};

export type Environment = typeof environment;
